import { atom } from "recoil";
import { IStoreViralitySettings } from "../types/wizard-types";

export const storeViralitySettingsAtom = atom<IStoreViralitySettings>({
  key: "storeViralitySettingsAtom",
  default: {
    enabled: 0,
    method: "fixed_points_value",
    value: undefined,
  },
});
